import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '../../../shared/button/button.module';
import { NotificationBarComponent } from './notification-bar.component';


@NgModule({
    declarations: [
        NotificationBarComponent,
    ],
    exports: [
        NotificationBarComponent,
    ],
    imports: [
        CommonModule,
        ButtonModule,
    ],
})
export class NotificationBarModule
{ }
